import axios from 'axios';
import { APISettings } from '../../config/ApiSettings';

const baseUrl = new APISettings().getApiURL();

class SubscriptionUserApi {
  public loginSubscriptionUser = (email: string, password: string) => {
    let userLoginObject = {
      "userEmail": email,
      "password": password,
      "newPassword": password
    };

    return axios.post(`${baseUrl}/SubscriptionUser/Login/`, userLoginObject);
  }

  public createLoginSubscriptionUser = (email: string, password: string, passwordConfirmation: string) => {
    let userLoginObject = {
      "userEmail": email,
      "password": password,
      "newPassword": passwordConfirmation
    };

    return axios.post(`${baseUrl}/SubscriptionUser/`, userLoginObject);
  }

  public initiatePasswordReset = (email: string) => {
    let userLoginObject = {
      "userEmail": email,
      "password": "",
      "newPassword": ""
    };

    return axios.post(`${baseUrl}/SubscriptionUser/InitiatePasswordReset/`, userLoginObject);
  }

  public resetPassword = (email: string, password: string, passwordConfirmation: string, resetToken: string) => {
    let userLoginObject = {
      "userEmail": email,
      "password": password,
      "newPassword": passwordConfirmation
    };

    return axios.put(`${baseUrl}/SubscriptionUser/ResetPassword/${resetToken}`, userLoginObject);
  }

  public changePassword = (email: string, oldPassword: string, newPassword: string) => {
    let userLoginObject = {
      "userEmail": email,
      "password": oldPassword,
      "newPassword": newPassword
    };

    return axios.put(`${baseUrl}/SubscriptionUser/ChangePassword`, userLoginObject);
  }

  public activateAccount = (email: string, activationToken: string) => {
    let userLoginObject = {
      "userEmail": email,
      "password": "",
      "newPassword": "",
    };

    return axios.post(`${baseUrl}/SubscriptionUser/Activate/${activationToken}`, userLoginObject);
  }

  public getActiveUsers: () => Promise<any> = async () => {
    let response = await axios.get(`${baseUrl}/SubscriptionUser/activeUsers`);
    return response.data.output;
  };

  public deactivate: (userId: string) => Promise<any> = async (userId: string) => {
    let userObject = {
       "Id": userId,
       "emailAddress": "",
       "passwordHash": "",
       "passwordSalt": "",
       "registeredDate": new Date(),
       "acctDisabled": false,
       "activationKey": ""
    };

    var response = await axios.put(`${baseUrl}/SubscriptionUser/deactivate`, userObject);
    return response.data.output;
  };
}

export const subscriptionUserAPI = new SubscriptionUserApi();